export default __webpack_public_path__ + "static/media/chartres.8fa3046a.jpg";